<div mat-dialog-content class="form-container">
  <form [formGroup]="datosTransportista" class="form__datosGestorContratista">
    <h1>Alta Transportista</h1>

    <p class="info">Seleccione un <strong>Transportista</strong> de la lista:</p>
    <div class="datos__datos">
    <mat-form-field appearance="outline">
      <mat-label>Denominación</mat-label>
      <mat-select name="transportista" [(value)]="transportistaSeleccionado" >
        <mat-option value="0">No está mi transportista</mat-option>
        <mat-option *ngFor="let transportista of transportistas" [value]="transportista.id">
          {{transportista.nombre}}
        </mat-option>
      </mat-select>
      <mat-hint class="hint">Si no encuentra su transportista, por favor, complete los datos a continuación</mat-hint>
    </mat-form-field>
  </div>
  <div class="boton__siguienteGestor">
    <button
      type="submit"
      (click)="getTransportistaById()"
    >
    Hecho
    </button>
  </div>
  <h2>Datos Transportista</h2>
  <p class="info">Si ha seleccionado un Transportista de la lista, por favor, confirme los datos a continuación.</p>
  <p class="info">En caso de que su Transportista no se encuentre en la lista, por favor, complete los siguientes datos.</p>
    <div class="datos__datos">
      <mat-form-field appearance="outline">
        <mat-label>Denominación</mat-label>
        <input
          matInput
          placeholder="Denominación"
          formControlName="nombre"
          required
        />
      </mat-form-field>
      <mat-form-field appearance="outline" style="width: 97%; margin-bottom: 5px;">
        <mat-label>CIF</mat-label>
        <input matInput placeholder="CIF" formControlName="cif" required />
        <mat-error >Campo obligatorio, por favor introduzca un número de Cif válido</mat-error>
      </mat-form-field>   
      <mat-form-field appearance="outline">
        <mat-label>Código Transportista</mat-label>
        <input matInput placeholder="Código Transportista" formControlName="codigo" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>NIMA</mat-label>
        <input matInput placeholder="Nima" formControlName="nima" required />
      </mat-form-field>
    </div>

    <h2>Información de Contacto</h2>
    <div class="form__datosGestorContratista">
      <form [formGroup]="datosContacto"  >
      <div class="datos__contacto">
      <mat-form-field appearance="outline">
        <mat-label>Nombre y apellido de Contacto</mat-label>
        <input
          matInput
          placeholder="Nombre y apellido"
          formControlName="nombre"
          required
        />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>Mail de Contacto</mat-label>
        <input
          matInput
          placeholder="mail"
          formControlName="mail"
          required
        />
      </mat-form-field>
    </div>
      <form [formGroup]="policy">
        <div class="privacidad2">
          <input type="checkbox" id="privacidad" formControlName="policy"/>
          <label for="privacidad" id="privacidad" > He leido y acepto la <a href="https://xtensa.es/politica/"  target="_blank">Politica de Privacidad</a> *</label>
          <p id="proteccion">
            El responsable del tratamiento de los datos es INPRONET SOLUTIONS SL. La finalidad de la recogida de datos es la de poder atender sus cuestiones, sin ceder sus datos a terceros. Tiene derecho a saber qué información tenemos sobre usted, corregirla o eliminarla tal y como se explica en nuestra Política de Privacidad.</p>
        </div>
      </form>
      </form>
    </div>
    <div *ngIf="transportistaSeleccionado !== '0'">
     <div class="warning">
      <p>Para ver la Documentación del Transportista Seleccionado, por favor vaya a detalles del Transportista haciendo click en el Transportista de la tabla</p>
      </div>
    <div class="boton__siguienteGestor">
      <button
        type="submit"
        [mat-dialog-close]
        [disabled]= "datosContacto.invalid"
        (click)="updateTransportistaById()"
      >
        Confirmar Datos
      </button>
    </div>
    </div>
    

    <div *ngIf="transportistaSeleccionado === '0'">
      <h2>Documentación</h2>
      <div class="documentos-form">
      <h3>Autorización 1</h3>
      <p>A continuación debe subir la Autorización 1</p>
      <div class="docpropia__drop">
        <ngx-file-drop dropZoneClassName="drop" contentClassName="drop_content" dropZoneLabel="Drop files here" (onFileDrop)="dropped($event)">
        <ng-template ngx-file-drop-content-tmp 
            let-openFileSelector="openFileSelector">
           <ng-container *ngIf="nameDocumento">{{nameDocumento}}</ng-container>
           <ng-container *ngIf="!nameDocumento">Puedes soltar aquí los documentos o</ng-container>
            <button type="button" class="boton_drop" (click)="openFileSelector()">Seleccionar un archivo</button>
        </ng-template>
        </ngx-file-drop>
    </div>
    <div>
      <form [formGroup]="datosDocumento" >
      <p>Seleccione la <strong> Fecha de Emisión</strong>: </p>
      <mat-form-field appearance="outline" class="example-form-field">
          <mat-label>Fecha de Emisión</mat-label>
          <input matInput 
              required 
              formControlName="fechaValidez"
              [matDatepicker]="datepicker">
          <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
          <mat-datepicker #datepicker>
            <mat-datepicker-actions>
              <button mat-button matDatepickerCancel>Cancelar</button>
              <button mat-raised-button color="primary" matDatepickerApply >Hecho</button>
            </mat-datepicker-actions>
          </mat-datepicker>
        </mat-form-field>
        <p>Seleccione una de las siguientes opciones para la <strong>Fecha de Caducidad</strong>:</p>
        <div class="caducidad">
          <div>
            <mat-form-field appearance="outline" class="example-form-field">
              <mat-label>Fecha de Caducidad</mat-label>
              <input matInput 
                  formControlName="fechaCaducidad"
                  [matDatepicker]="datepicker1">
              <mat-datepicker-toggle matSuffix [for]="datepicker1"></mat-datepicker-toggle>
              <mat-datepicker #datepicker1>
                <mat-datepicker-actions>
                  <button mat-button matDatepickerCancel>Cancelar</button>
                  <button mat-raised-button color="primary" matDatepickerApply >Hecho</button>
                </mat-datepicker-actions>
              </mat-datepicker>
            </mat-form-field>
          </div>
          <div >
            <div class="radio__caduca">
              <div>
                <input
                  type="radio"
                  [value]= true
                  id="si"
                  formControlName="noCaduca"
                />
                <label for="si">No caduca</label>
              </div>
            </div>
          </div>
        </div>
      </form>
      </div>
      <div class="warning"> 
        <p>Para ver la Documentación del Transportista que ha creado, por favor vaya a detalles del Transportista haciendo click en el Transportista de la tabla</p>
      </div>
      <button
        type="submit"
        [mat-dialog-close]
        [disabled]="datosTransportista.invalid"
        (click)="addTransportista()"
      >
        Hecho
      </button>
     
  </div>
  </div>
  </form>
</div>
